import {RoomContainerModel} from "./room-container.model";
import {DataListModel} from "./data-list.model";

export class RoomContainersModel extends DataListModel {
  items: RoomContainerModel[] = [];
}
